export default __webpack_public_path__ + "static/media/due-date-icon.a852c599.svg";